module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAo0lEQVQokY3SMQ5BMQAG4I5euIFr2MxidjEuQOIYRgcwidgkwixGi/gM+pJqWk+Tpmn7f8vfBpywR4Pwx5zgGHD1GYc/8ChmBQwi6sIjvGJu2R42HThFa4T0Mse9GsphjreY4ZmjEmzxxvdY5Llae+ME3UuZWnu3iB5x3eWF/ap8jqHP52gLa0qw2J7KU3WhGu4HTJMiSqiELwHnuFn9QCnewxtNT46y7VC1/QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_close1.png
// module id = qh92
// module chunks = 1